function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".companya{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2118.316 -5492.462)"
}, /*#__PURE__*/React.createElement("path", {
  className: "companya",
  d: "M2138.119,5516.86h-17.6a2.2,2.2,0,0,1-2.2-2.2v-9.511a2.2,2.2,0,0,1,2.2-2.2h17.6a2.2,2.2,0,0,1,2.2,2.2v9.511A2.2,2.2,0,0,1,2138.119,5516.86Zm-17.6-12.335a.627.627,0,0,0-.626.626v9.511a.627.627,0,0,0,.626.626h17.6a.627.627,0,0,0,.626-.626v-9.511a.627.627,0,0,0-.626-.626Z",
  transform: "translate(0 -7.744)"
}), /*#__PURE__*/React.createElement("path", {
  className: "companya",
  d: "M2152.712,5496h-1.571v-1.2a.763.763,0,0,0-.762-.762h-3.649a.763.763,0,0,0-.762.762v1.2H2144.4v-1.2a2.336,2.336,0,0,1,2.333-2.333h3.649a2.336,2.336,0,0,1,2.333,2.333Z",
  transform: "translate(-19.25)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2123.866 5495.995)"
}, /*#__PURE__*/React.createElement("path", {
  className: "companya",
  d: "M2142.574,5515.531h-2a1.067,1.067,0,0,1-1.065-1.065v-2.808a1.016,1.016,0,0,1,.347-.817l.052-.052.078-.059,1.593-1.092,1.691,1.2a1.062,1.062,0,0,1,.373.821v2.808A1.067,1.067,0,0,1,2142.574,5515.531Zm-1.5-1.571h.99v-2.068l-.5-.345-.493.338Z",
  transform: "translate(-2139.506 -5508.673)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "companya",
  width: 1.571,
  height: 2.001,
  transform: "translate(1.281)"
})), /*#__PURE__*/React.createElement("rect", {
  className: "companya",
  width: 1.571,
  height: 12.336,
  transform: "translate(2121.198 5495.995)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "companya",
  width: 1.571,
  height: 12.336,
  transform: "translate(2135.844 5495.995)"
}));

var SvgCompany = function SvgCompany(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16.654,
    viewBox: "0 0 22 16.654",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompany, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company.a5435694.svg";
export { ForwardRef as ReactComponent };